import styled, { css } from "styled-components";
import { color, units, variant } from "@m/alchemy-theme";
const overlayAdornment = css `
  position: absolute;
  top: 0;
  bottom: 0;
  line-height: 1;
`;
export const FieldAdornment = styled.div `
  color: ${color("base", { palette: "expressiveNeutral" })};
  z-index: 1;
  min-height: 24px;
  justify-content: center;
  text-align: center;
  display: flex;
  align-items: center;
  padding-left: ${units(0.75)};
  padding-right: ${units(0.75)};
  padding-top: ${units(0.5)};
  padding-bottom: ${units(0.5)};

  ${variant("position", {
    start: css `
      ${overlayAdornment};
      left: 0;
    `,
    end: css `
      ${overlayAdornment};
      right: var(--end-adornment-offset, 0px);
    `,
    gutter: css `
      padding-left: ${units(0.5)};
      padding-right: 0;
    `
})};
`;
